import { memo } from 'react';
import { default as ReactGA4 } from 'react-ga4';
import { useSelector } from 'react-redux';
import { UrlUtils } from 'src/utils';
import { isMiniappSelector } from 'src/selectors/app';
import { Element } from 'src/components';

const FacebookButton = (props: any) => {
    const { children, className, link, title, hide, ...buttonProps } = props;
    const isMiniapp = useSelector(isMiniappSelector);
    const handleClick = () => {
        const urlShare = UrlUtils.buildFacebookShareLink(link);
        window.open(urlShare, 'share', 'height=600,width=600');
        if (hide) {
            hide();
        }
        ReactGA4.event({
            category: 'mobile_facebook',
            action: 'share',
            label: title,
        });

        return false;
    };

    if (isMiniapp) {
        return null;
    }

    return (
        <Element
            renderAs="button"
            title="Chia sẻ qua Facebook"
            onClick={handleClick}
            className={className}
            {...buttonProps}
        >
            {children}
        </Element>
    );
};

export default memo(FacebookButton);
